import type { UIMessage } from 'ai';
import type { AssistantModelKey } from './models/types';

export type AssistantThinkingKey = Extract<AssistantModelKey, 'default' | 'reasoning'>;

export type AssistantRunPresentation = {
  key: AssistantModelKey;
  thinkingLabel: 'Standard' | 'Deeper';
  modelLabel: string;
};

export function assistantRunPresentation(key: AssistantModelKey): AssistantRunPresentation {
  if (key === 'reasoning') {
    return { key, thinkingLabel: 'Deeper', modelLabel: 'GPT-5.6 Luna' };
  }
  if (key === 'multimodal') {
    return { key, thinkingLabel: 'Standard', modelLabel: 'Gemini 3.7 Flash' };
  }
  return { key, thinkingLabel: 'Standard', modelLabel: 'GPT-5.6 Luna' };
}

export function assistantRunPresentationSummary(presentation: AssistantRunPresentation): string {
  return `Answered with ${presentation.modelLabel} · ${presentation.thinkingLabel} thinking`;
}

export function attachAssistantRunPresentation(
  message: UIMessage,
  key: AssistantModelKey,
): UIMessage {
  if (message.parts.some((part) => part.type === 'data-run-model')) return message;
  return {
    ...message,
    parts: [{ type: 'data-run-model', data: assistantRunPresentation(key) }, ...message.parts],
  };
}
